import { StringHelpers, SystemText } from 'e4shared';
import { e4Format, isPast, isToday } from 'helpers/dates';

export const Bullet = ({ style, icon, type, value, isDate, isDuration }) => {
    if (isDate) {
        if (isToday(value)) {
            value = SystemText('Controls/Bullet/Today');
            icon = 'triangle-exclamation';
            style = 'due';
        } else if (isPast(value)) {
            value = SystemText('Controls/Bullet/Overdue');
            icon = 'circle-exclamation';
            style = 'overdue';
        } else {
            value = SystemText('Controls/Bullet/Due', e4Format(value));
            icon = 'calendar';
            style = 'steel';
        }
    }

    if (isDuration) {
        icon = 'clock';
        style = 'desert';
        value = StringHelpers.displayMinutes(value);
    }

    switch (type) {
        case 'behavior':
            icon = 'user-gear';
            value = SystemText('Controls/Bullet/Type/Behavior');
            break;
        case 'course':
            icon = 'arrow-up-right-from-square';
            value = SystemText('Controls/Bullet/Type/Course');
            break;
        case 'objective':
            icon = 'square-check';
            value = SystemText('Controls/Bullet/Type/Objective');
            break;
        case 'pathway':
            icon = 'rocket';
            value = SystemText('Controls/Bullet/Type/Pathway');
            break;
        case 'review':
            icon = 'gauge';
            value = SystemText('Controls/Bullet/Type/Review');
            break;
        default:
            break;
    }

    return (
        <div className={`prism-bullet no-wrap ${style}`}>
            {icon && <i className={`fa fa-${icon} mr10`} />}
            {value}
        </div>
    );
};

export default Bullet;
